import { Controller } from "react-hook-form";
import { lang } from "../../Utils/lang";
import { TextField } from "@mui/material";

export default function Documents(props: any) {
  const { control } = props;

  return (
    <>
      <Controller
        name="nrContract"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="nrContract"
            label={lang.nrContract}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="nrProforma"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="nrProforma"
            label={lang.nrProforma}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="serieContract"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="serieContract"
            label={lang.serieContract}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="serieProforma"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="serieProforma"
            label={lang.serieProforma}
            size="small"
            variant="outlined"
          />
        )}
      />
    </>
  );
}
